import { useState } from 'react';
import { useNavigate } from "react-router";
import { useApiSubmit } from '../../api_client';

import './login.css';

const LoginTile = () => {
  const [formData, setFormData] = useState({
    password: '',
  });
  const [error, setError] = useState('');
  const { submitData, loading, error: apiError } = useApiSubmit();
  let navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.password) {
      setError('Please fill in all fields');
      return;
    }

    try {
      // Submit login data to the API
      const result = await submitData('/api/login', {
        username: formData.username,
        password: formData.password
      });
      console.log('Login successful', result);
      localStorage.setItem("euans_website", result['access_token'])
      navigate("/")
    } catch (err) {
      setError(apiError || 'Login failed');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <form onSubmit={handleSubmit}>

          <div className="form-group">
            <input
              id="password"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter euan's password"
            />
          </div>

          {error && (
            <div className="error-message">{error}</div>
          )}

          <button type="submit">
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}

export const Login = () => {
  return (
    <div className='login_main'>
      <LoginTile />
    </div>
  )
}
